import type { InfiniteData, QueryClient } from "@tanstack/react-query";

// The lazy-loaded lists are infinite queries: invalidating them refetches every
// loaded page sequentially, which gets more expensive the further the user has
// scrolled — just to drop rows. Instead splice the reviewed videos out of the
// cached pages in place (instant, keeps pagination consistent) and mark the queries
// stale WITHOUT refetching, so whichever tab they moved to reconciles on next open.
export const spliceVideosFromCache = (queryClient: QueryClient, merchantId: string | undefined, videoIds: string[]) => {
  const ids = new Set(videoIds);
  queryClient.invalidateQueries({ queryKey: ["assurance-video", merchantId] });
  queryClient.setQueriesData<InfiniteData<{ videos: { videoId: string }[]; total: number }>>(
    { queryKey: ["assurance-video-infinite", merchantId] },
    (data) => {
      if (!data?.pages.some((p) => p.videos.some((v) => ids.has(v.videoId)))) return data;
      return {
        ...data,
        pages: data.pages.map((page) => {
          const removed = page.videos.filter((v) => ids.has(v.videoId)).length;
          return {
            ...page,
            videos: page.videos.filter((v) => !ids.has(v.videoId)),
            total: Math.max(0, page.total - removed),
          };
        }),
      };
    },
  );
  queryClient.invalidateQueries({
    queryKey: ["assurance-video-infinite", merchantId],
    refetchType: "none",
  });
};
